import { render, staticRenderFns } from "./VideoVisu.vue?vue&type=template&id=11af8d1c&lang=pug&"
import script from "./VideoVisu.vue?vue&type=script&lang=js&"
export * from "./VideoVisu.vue?vue&type=script&lang=js&"
import style0 from "./VideoVisu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11af8d1c')) {
      api.createRecord('11af8d1c', component.options)
    } else {
      api.reload('11af8d1c', component.options)
    }
    module.hot.accept("./VideoVisu.vue?vue&type=template&id=11af8d1c&lang=pug&", function () {
      api.rerender('11af8d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/library/VideoVisu.vue"
export default component.exports